// Whether the person has asked their device for less motion (the "reduce motion" setting). Anything that moves on
// its own (a card sliding in, a shake, a smooth scroll) checks it first and simply does the thing without the movement.
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** For scrollIntoView and scrollTo: smooth, unless motion is reduced. */
export function scrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : 'smooth';
}
